import { Partner } from "../constants/partner"
import { dartyPlugins } from "./darty"
import { type PartnerPluginSlot, type PartnerPluginsRegistry } from "./types"

/**
 * Registry of all partner plugins.
 * Add new partners here as they are created.
 */
const partnerPluginsRegistry: PartnerPluginsRegistry = {
    [Partner.Darty]: dartyPlugins,
    [Partner.DartyOctopus]: null,
    [Partner.Effy]: null,
}

export function getPartnerPlugin<TPartner extends Partner>(
    partner: TPartner | null,
    slot: PartnerPluginSlot
) {
    if (!partner) return undefined

    return partnerPluginsRegistry[partner]?.[slot]
}

getPartnerPlugin.messages = [...dartyPlugins.messages] as const
